import React from "react";
import CustomInput from "../../../components/CustomForm/CustomInput";
import CustomSelect from "../../../components/CustomForm/CustomSelect";
import CheckRender from "../../../components/Common/CheckRender";
import {
  FormWrapper,
  Form,
  FormGroup,
  Label,
} from "../../../components/CustomForm/FormStyles";
import {
  dataTipoServicio,
  dataTipoServicioPyp,
  dataArl,
  dataTipoTelefono,
  dataFisicoRequerido,
} from "../../../utils/LocalData";
import useEmpresa from "../../../hooks/useEmpresa";
import { formatPhoneNumber } from "../../../utils/StringUtil";
import CustomCheckbox from "../../../components/CustomForm/CustomCheckbox";
import Colors from "../../../themes/Colors";

const AutorizacionForm = ({
  data,
  diagnosticos,
  zonas,
  provincias,
  medicos,
  onStateChange,
  handleCheckboxChange,
  showRequired,
  disabled,
  setSelectedMedico,
  setSelectedDiagnostico,
  noRequiereFisico,
  prestadorEsPapperFree,
  getZonasLoading,
  getProvinciasLoading,
  getDiagnosticosLoading,
  getMedicosLoading,
  updatedSuggestionsMedicos,
  updatedSuggestionsDiagnosticos,
  autorizacionEsPyp,
  disableTipoServicio
}) => {
  const {
    fecha,
    tipoTelefono,
    telefono,
    tipoServicio,
    correo,
    esArl,
    medicoPrescriptor,
    diagnostico,
    requiereFisico,
    zona,
    provincia,
    observaciones,
    diagnosticoDefinitivo,
  } = data;

  const empresa = useEmpresa();

  return (
    <FormWrapper borderColor={empresa?.COLOR_PRINCIPAL}>
      <Form>
        <CheckRender allowed={prestadorEsPapperFree}>
          <FormGroup>
            <CustomSelect
              options={dataFisicoRequerido}
              label={"Requiere Físico"}
              value={requiereFisico}
              onChange={onStateChange("requiereFisico")}
              required={true}
              showRequired={showRequired}
              disabled={prestadorEsPapperFree}
              labelColor={empresa?.COLOR_SECUNDARIO}
              labelWeight={"bold"}
            />
          </FormGroup>
        </CheckRender>
        <FormGroup>
          <CustomInput
            type={"date"}
            placeholder={"Fecha"}
            label={"Fecha"}
            value={fecha}
            onChange={onStateChange("fecha")}
            required={true}
            disabled={disabled}
          />
        </FormGroup>
        <FormGroup>
          <CustomSelect
            options={dataTipoTelefono}
            label={"Tipo Teléfono"}
            value={tipoTelefono}
            onChange={onStateChange("tipoTelefono")}
            required={true}
            disabled={disabled}
          />
        </FormGroup>
        <FormGroup>
          <CustomInput
            type={"phone"}
            placeholder={"Teléfono"}
            label={"Teléfono"}
            value={telefono}
            onChange={onStateChange("telefono", formatPhoneNumber)}
            required={true}
            showRequired={showRequired}
            maxLength={14}
            disabled={disabled}
          />
        </FormGroup>
        <FormGroup>
          <CustomSelect
            options={autorizacionEsPyp ? dataTipoServicioPyp : dataTipoServicio}
            label={"Tipo de Servicio"}
            value={tipoServicio}
            onChange={onStateChange("tipoServicio")}
            required={true}
            showRequired={showRequired}
            showDefaultOption={!autorizacionEsPyp}
            disabled={disabled || autorizacionEsPyp || disableTipoServicio}
          />
        </FormGroup>
        <FormGroup>
          <CustomInput
            type={"email"}
            placeholder={"Correo Electrónico"}
            label={"Correo Electrónico"}
            value={correo}
            onChange={onStateChange("correo")}
            required={false}
            disabled={disabled}
          />
        </FormGroup>
        <FormGroup>
          <CustomInput
            type={"medicoPrescriptor"}
            placeholder={"Médico Prescriptor"}
            label={"Médico Prescriptor"}
            value={medicoPrescriptor}
            onChange={onStateChange("medicoPrescriptor")}
            required={true}
            showRequired={showRequired}
            disabled={disabled}
            suggestions={medicos}
            setSelectedSuggestion={setSelectedMedico}
            dataLoading={getMedicosLoading}
            updatedSuggestions={updatedSuggestionsMedicos}
          />
        </FormGroup>
        <FormGroup>
          <CustomInput
            type={"text"}
            placeholder={"Diagnóstico"}
            label={"Diagnóstico"}
            value={diagnostico}
            onChange={onStateChange("diagnostico")}
            required={noRequiereFisico}
            showRequired={showRequired}
            disabled={disabled}
            suggestions={diagnosticos}
            setSelectedSuggestion={setSelectedDiagnostico}
            dataLoading={getDiagnosticosLoading}
            updatedSuggestions={updatedSuggestionsDiagnosticos}
          />
        </FormGroup>
        <CheckRender allowed={noRequiereFisico}>
          <FormGroup>
            <Label font={empresa?.LETRA_PRINCIPAL}>
              Diagnóstico Definitivo?
            </Label>
            <CustomCheckbox
              checked={diagnosticoDefinitivo}
              checkedColor={empresa?.COLOR_PRINCIPAL}
              uncheckedColor={Colors.blueTransparent}
              checkmarkColor={Colors.white}
              onChange={handleCheckboxChange("diagnosticoDefinitivo")}
            />
          </FormGroup>
        </CheckRender>
        <FormGroup>
          <CustomSelect
            options={dataArl}
            label={"ARL"}
            value={esArl}
            onChange={onStateChange("esArl")}
            required={true}
            showRequired={showRequired}
            disabled={disabled}
          />
        </FormGroup>
        <CheckRender allowed={noRequiereFisico}>
          <FormGroup>
            <CustomSelect
              options={zonas}
              label={"Zona"}
              value={zona}
              showDefaultOption={true}
              onChange={onStateChange("zona")}
              required={true}
              disabled={disabled}
              showRequired={showRequired}
              dataLoading={getZonasLoading}
            />
          </FormGroup>
          <FormGroup>
            <CustomSelect
              options={provincias}
              label={"Provincia"}
              value={provincia}
              showDefaultOption={true}
              onChange={onStateChange("provincia")}
              required={true}
              disabled={disabled}
              showRequired={showRequired}
              dataLoading={getProvinciasLoading}
            />
          </FormGroup>
          <FormGroup>
            <CustomInput
              type={"text"}
              placeholder={"Observaciones"}
              label={"Observaciones"}
              value={observaciones}
              onChange={onStateChange("observaciones")}
              required={false}
              showRequired={showRequired}
              disabled={disabled}
            />
          </FormGroup>
        </CheckRender>
      </Form>
    </FormWrapper>
  );
};

export default AutorizacionForm;
